module.exports = __webpack_public_path__ + "static/media/Raffrollo_35618_80x160.75af9f48.png";